<template>
    <div class="room__docs">
        <div class="room__secondary-videobox" v-if="sessionLoad && (windowWidth > 1000 || !streams.length)">
            <div class="room__videobox">
                <publisher :opts="{width: '100%', height: '100%'}"></publisher>
            </div>
        </div>
        <div class="room__maininfo">
            <attachments-screen></attachments-screen>
            <recept-screen></recept-screen>
            <report-screen></report-screen>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import Publisher from "./opentok/Publisher";
    import AttachmentsScreen from "./attachment/AttachmentsScreen.vue";
    import ReceptScreen from "./recept/ReceptScreen";
    import ReportScreen from "./report/ReportScreen";

    export default {
        name: "RoomDocs",
        components: {
            Publisher,
            AttachmentsScreen,
            ReceptScreen,
            ReportScreen,
        },
        computed: {
            ...mapState([
                'windowWidth',
                'user',
            ]),
            ...mapState('conference', [
                'streams',
                'sessionLoad',
            ])
        }
    }
</script>
